import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '*',
    name: '404',
    component: () => import('../views/error/errorPage.vue')
  },
  { path: '/', redirect: '/index' },
  { path: '/index', component: () => import('../views/home.vue') },
]

const router = new Router({
  // mode: 'history',
  routes,
})
// 挂载导航路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  } else {
    document.title = 'NASCC'
  }
  // const whiteList = [
  //   '/login',
  // ]
  // if (whiteList.includes(to.path)) return next()
  // if (!localStorage.getItem('Authorization')) return next('/login')
  next()
})
export default router
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
